import { render, staticRenderFns } from "./newToolbar.vue?vue&type=template&id=2ff2c33e&scoped=true"
import script from "./newToolbar.vue?vue&type=script&lang=js"
export * from "./newToolbar.vue?vue&type=script&lang=js"
import style0 from "./newToolbar.vue?vue&type=style&index=0&id=2ff2c33e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ff2c33e",
  null
  
)

export default component.exports